// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeleteEmployeeDeductionResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/delete_employee_deduction
 * Returns success message
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_DeleteEmployeeDeductionResponseDados = string;

export type Payroll_DeleteEmployeeDeductionResponse = ApiResponse<Payroll_DeleteEmployeeDeductionResponseDados>;

registerResponseContract('Payroll_DeleteEmployeeDeductionResponse', {})
